module.exports = __webpack_public_path__ + "static/icon-teams@3x.51214a70.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-teams@3x.png
// module id = 246
// module chunks = 168707334958949